export default {
    events: state => state.events,
    notes: state => state.notes,
    qbToken: state => state.qbToken,
    qbRefreshToken: state => state.qbRefreshToken,
    manageEventDialog: state => state.manageEventDialog,
    manageNoteDialog: state => state.manageNoteDialog
}
